import gql from 'graphql-tag'

export const GET_MACHINE = gql`
  query GetMachine($id: ID!, $from: String!, $to: String!) {
    reportFleetStateMachine(id: $id, from: $from, to: $to)
  }
`
